import * as types from "../../constants/actionTypes";

const initState = {
  isLoading: false,
  listReservasi: [],
  listReservasiDokter: [],
  totalPemasukan: 0,
  reportKunjunganPasien: {
    legendaDays: "",
    totalSemuaPasien: "",
    totalPasienBerhasil: "",
    totalPasienBatal: "",
  },
};

export default function (state = initState, action) {
  switch (action.type) {
    case types.DASHBOARD_SET_LOADER: {
      return {
        ...state,
        isLoading: action.value,
      };
    }
    case types.GET_LIST_RESERVASI_SUCCESS: {
      return {
        ...state,
        listReservasi: action.value,
      };
    }
    case types.DASHBOARD_ADMISI_PEMASUKAN_HARIAN_SUCCESS: {
      return {
        ...state,
        totalPemasukan: action.value ? action.value.totalPemasukan : "-",
      };
    }
    case types.DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS: {
      return {
        ...state,
        reportKunjunganPasien: action.value,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
